import { TriggerPayloadConfiguration } from './trigger-payload-configuration';

export class EmptyTriggerPayloadConfiguration extends TriggerPayloadConfiguration {
	public constructor() {
		super(false, false, false, false);
	}
}
